var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.iconVisible)?_c('ad-info-block',{attrs:{"showOnMobileFullScreen":true,"placement":_vm.placement,"fallbackPlacement":_vm.fallbackPlacement}},[_c('span',[_vm._v(_vm._s(_vm.popoverText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }